import { apiCore } from "./apiCore";
import { ITemplateResponse } from "../types/template";

export const loadTemplates = async (): Promise<ITemplateResponse> => {
  const response = await apiCore<ITemplateResponse>("/DootChat/Templates", {
    method: "GET",
  });

  return response.data;
};
